import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import { CITIES, cityToSlug } from '../../shared/utils/cities';

import { Alert, Avatar, Badge, Button, Col, Tooltip } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import SvgPin from '../Icons/Pin';
import SvgVerified from '../Icons/Verifed';
import SvgCategory from '../Icons/Category';
import { storageImage } from '../../shared/utils/storage-image';

export default function ListDetailLeftColumn({
  logoUrl,
  mediaUrl,
  mediaType,
  title,
  location,
  category,
  avatar,
  userActive,
  verified,
  xs = 24,
  lg = 6,
}: {
  logoUrl?: string;
  mediaUrl?: string;
  mediaType?: string;
  title?: string;
  location?: string;
  category?: string;
  avatar?: string;
  userActive?: boolean;
  verified?: boolean;
  xs?: number;
  lg?: number;
}) {
  const { t } = useTranslation();
  const [mediaFailed, setMediaFailed] = useState(false);
  useEffect(() => setMediaFailed(false), [mediaUrl]);
  const isAvatarMode = avatar !== undefined;
  const citySlug = location ? cityToSlug(location) : '';
  const wrapperClass = isAvatarMode
    ? 'list-detail-left-wrapper'
    : 'list-detail-left-wrapper list-detail-left-wrapper--horizontal';

  return (
    <Col xs={xs} lg={lg}>
      <div className={wrapperClass}>
        <div className="list-detail-image-wrapper">
          {logoUrl && !mediaUrl && (
            // Logos are square; intrinsic size reserves space before load (CLS). CSS caps the size.
            <img
              className="list-detail-image"
              src={storageImage(logoUrl, 240)}
              alt={title}
              width={240}
              height={240}
              loading="eager"
              {...({ fetchpriority: 'high' } as any)}
              onError={(e) => { if (!e.currentTarget.src.endsWith('/images/default.jpg')) e.currentTarget.src = '/images/default.jpg'; }}
            />
          )}
          {mediaUrl && mediaType !== 'video/mp4' && (
            <img
              className="list-detail-image"
              src={storageImage(mediaUrl, 240)}
              alt={title}
              loading="eager"
              {...({ fetchpriority: 'high' } as any)}
              onError={(e) => { if (!e.currentTarget.src.endsWith('/images/default.jpg')) e.currentTarget.src = '/images/default.jpg'; }}
            />
          )}
          {mediaUrl && mediaType === 'video/mp4' && (
            mediaFailed ? <Alert type="warning" showIcon message={t('mobile.mediaUnavailable')}
              action={<Button onClick={() => setMediaFailed(false)}>{t('searchBox.retry')}</Button>} /> :
              // No caption resource is supplied by the existing training data.
              // eslint-disable-next-line jsx-a11y/media-has-caption
              <video className="list-detail-video" src={mediaUrl} aria-label={title}
                controls playsInline preload="metadata" onError={() => setMediaFailed(true)} />
          )}
          {(avatar || avatar === null) && (
            <div className="list-detail-avatar-wrapper">
              <Badge
                dot={true}
                color={userActive ? 'var(--tn-success)' : 'var(--tn-neutral)'}
                offset={[-35, 160]}
                style={{ width: '20px', height: '20px' }}
              >
                <Avatar
                  src={storageImage(avatar, 180)}
                  size={180}
                  icon={<UserOutlined />}
                />
              </Badge>
            </div>
          )}
        </div>
        <div className="list-detail-summary">
          <div className="list-detail-summary-title-wrapper">
            <h1>{title}</h1>
            {verified ? (
              <Tooltip title={t('listDetail.verifiedAccount')}>
                <SvgVerified />
              </Tooltip>
            ) : (
              ''
            )}
          </div>
          {location && (
            <p>
              <SvgPin />
              {CITIES[citySlug] ? <Link href={`/sehir/${citySlug}`}><a>{location} tenis rehberi</a></Link> : location}
            </p>
          )}
          {category && (
            <p>
              <SvgCategory />
              {category}
            </p>
          )}
        </div>
      </div>
    </Col>
  );
}
